import { fetchJson, reportErrorAndShowMessage } from "js/includes/common/utils"

export default class FileUpload {
  constructor() {
    this.xhr = undefined
    this.state = {
      hideMfaModal: false,
    }
  }

  cancelEvents() {
    if (this.xhr && this.xhr.upload) {
      this.xhr.abort()
    }
  }

  async upload({
    file,
    fullFileName,
    onUploadProgress,
    onUploadSuccess,
    onUploadFailure,
    onUploadStarted,
    onUploadFinished,
  }) {
    const fileName = file.name

    try {
      const { signature, policy, awsS3UploadBucketUrl, accessKeyId, key } = await fetchJson(
        "/webapp/aws/s3/signpolicy-mfasecured",
        {
          options: {
            method: "POST",
            body: fileName,
          },
        },
      )

      const fd = new FormData()
      fd.append("key", key)
      fd.append("acl", "public-read")
      fd.append("Content-Type", file.type)
      fd.append("AWSAccessKeyId", accessKeyId)
      fd.append("policy", btoa(policy))
      fd.append("signature", signature)
      fd.append("file", file)

      this.xhr = new XMLHttpRequest()

      this.xhr.upload.addEventListener(
        "progress",
        function(evt) {
          if (evt.lengthComputable) {
            const percentageUploaded = Math.round((evt.loaded / evt.total) * 100)
            onUploadProgress(percentageUploaded)
          }
        },
        false,
      )

      this.xhr.addEventListener("loadstart", onUploadStarted, false)

      this.xhr.addEventListener(
        "loadend",
        () => {
          if (this.xhr.status === 400) {
            onUploadFailure()
          }
          onUploadFinished()
        },
        false,
      )

      this.xhr.addEventListener(
        "load",
        () => {
          const location = this.xhr.getResponseHeader("location")
          if (!location) {
            throw new Error("Location Header from S3 Bucket Response could not be accessed")
          }
          onUploadSuccess(location, file.name)
        },
        false,
      )
      this.xhr.addEventListener("error", onUploadFailure, false)

      this.xhr.addEventListener("abort", onUploadFailure, false)
      this.xhr.addEventListener("timeout", onUploadFailure, false)

      // MUST BE LAST LINE BEFORE YOU SEND
      this.xhr.open("POST", awsS3UploadBucketUrl, true)
      this.xhr.send(fd)
    } catch (error) {
      reportErrorAndShowMessage(error)
    }
  }
}
